import EnumObject from '../../enum-object.entity';

export default class ContractItemRuleReport {
  id: string;

  code: string;

  status: EnumObject;

  versionDate: string;

  customerName: string;

  customerDocument: string;

  customerTradingName: string;

  externalId: number;

  resultCenter: string;

  isBillingEnabled: boolean;

  beneficiary: string;

  billingDisabledJustificationName: string;

  instance: string;

  itemNumber: number;

  itemDescription: string;

  itemFrequency: EnumObject

  ruleName: string;

  ruleParameters: string;

  currencyConvertion: string;

  contractGroupName: string;

  contractPlanName: string;

  lastUpdatePlan: string;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.code = obj.code || '';
    this.status = EnumObject.of(obj.status) || {};
    this.versionDate = obj.versionDate || '';
    this.customerName = obj.customerName || '';
    this.customerDocument = obj.customerDocument || '';
    this.customerTradingName = obj.customerTradingName || '';
    this.externalId = obj.externalId || 0;
    this.resultCenter = obj.resultCenter || '';
    this.isBillingEnabled = obj.isBillingEnabled;
    this.beneficiary = obj.beneficiary || '';
    this.billingDisabledJustificationName = obj.billingDisabledJustificationName || '';
    this.instance = obj.instance || '';
    this.itemNumber = obj.itemNumber || null;
    this.itemDescription = obj.itemDescription || '';
    this.itemFrequency = obj.itemFrequency || '';
    this.ruleName = obj.ruleName || '';
    this.ruleParameters = obj.ruleParameters || '';
    this.currencyConvertion = obj.currencyConvertion || '';
    this.contractGroupName = obj.contractGroupName || '';
    this.contractPlanName = obj.contractPlanName || '';
    this.lastUpdatePlan = obj.lastUpdatePlan || '';
  }

  public static of(obj: any): ContractItemRuleReport {
    return new ContractItemRuleReport(obj || {});
  }

  public static ofList(obj: any[]): ContractItemRuleReport[] {
    return obj.map(this.of);
  }

  get billingEnabledDescription() : string {
    return this.isBillingEnabled
      ? 'Sim' : `Não - ${this.billingDisabledJustificationName}`
  }

  get isInactive(): boolean {
    return this.status.value === 'INACTIVE'
  }

  get isCanceled(): boolean {
    return this.status.value === 'CANCELED'
  }
}
